import DisableDesktopOrders from './DisableDesktopOrders'

export default DisableDesktopOrders
